import { render, staticRenderFns } from "./freedays.vue?vue&type=template&id=a57b628e&"
import script from "./freedays.vue?vue&type=script&lang=js&"
export * from "./freedays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports